import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import useCountDownTimer from 'client/hooks/useCountDownTimer';

const SrCountdownClock = ({ endDate, text, className }) => {
  const countDownTimer = useCountDownTimer({ endDate });

  return (
    <div className={classnames('CountdownClock', className)}>
      <span className="timestampDescription">{text}</span>
      <div className="timestamp">
        <img alt="clock disabled" src="/images/clock-large-green.svg" className="clockIcon" />
        <img
          alt="clock"
          src="/images/clock-large-white.svg"
          className={classnames('clockIcon', 'disabledClockIcon')}
        />
        <span className="timestampValue">{countDownTimer.time}</span>
        <span className={classnames('timestampValue', 'placeholderTimestamp')}>24h 00m 00s</span>
      </div>
    </div>
  );
};

SrCountdownClock.propTypes = {
  endDate: PropTypes.string,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

SrCountdownClock.displayName = 'SrCountdownClock';

export default SrCountdownClock;
